import { IMeasurementDto, IUsedArticle } from "@/data/web-api-client";

export default {
    summary(data: IMeasurementDto, articles: any, rawmaterials: any) {
        const result: {
            codes: {
                id: string,
                amount: number,
                measuringUnit: string,
            }[],
            rawmaterials: {
                id: string,
                amount: number,
                measuringUnit: string,
                convertionsRate: number,
                defaultOrderMeasuringUnit: string,
            }[],
            expectedDurationInMinutes: number,
        } = {
            codes: [],
            rawmaterials: [],
            expectedDurationInMinutes: 0,
        };

        data.rooms!.forEach((room) => {
            room.usedArticles!.forEach((usedArticle) => {
                if (!usedArticle.articleId) {
                    return;
                }

                const foundItem = result.codes.find((o) => o.id === usedArticle.articleId);
                if (foundItem) {
                    foundItem.amount += this.calculateAmountFromLine(usedArticle);
                } else {
                    const article = articles.find((o: any) => o.id === usedArticle.articleId);
                    result.codes.push({
                        id: usedArticle.articleId,
                        amount: this.calculateAmountFromLine(usedArticle),
                        measuringUnit: article ? article.measuringUnit : '',
                    });
                }
            });
        });

        result.codes.forEach((codeEntry) => {
            const article = articles.find((o: any) => o.id === codeEntry.id);
            if (!article || !article.variants || article.variants.length === 0) {
                return;
            }

            // RAW MATERIALS
            article.variants[0].materials.forEach((rawMaterialEntry: any) => {
                const foundRawMaterial = result.rawmaterials.find((o) => o.id === rawMaterialEntry.rawMaterialRef);
                if (foundRawMaterial) {
                    foundRawMaterial.amount += rawMaterialEntry.amount * codeEntry.amount;
                } else {
                    const rawMaterial = rawmaterials
                        .find((o: any) => o.id === rawMaterialEntry.rawMaterialRef);
                    if (rawMaterial) {
                        let conversionRate = 1;

                        if (rawMaterial.defaultPrice.convertAmountA &&
                            rawMaterial.defaultPrice.convertAmountA !== null &&
                            rawMaterial.defaultPrice.convertAmountB &&
                            rawMaterial.defaultPrice.convertAmountB !== null
                        ) {
                            conversionRate = rawMaterial.defaultPrice.convertAmountA / rawMaterial.defaultPrice.convertAmountB;
                        }

                        result.rawmaterials.push({
                            id: rawMaterialEntry.rawMaterialRef,
                            amount: rawMaterialEntry.amount * codeEntry.amount,
                            measuringUnit: rawMaterial.measuringUnit,
                            convertionsRate: conversionRate,
                            defaultOrderMeasuringUnit: rawMaterial.defaultPrice ?
                                rawMaterial.defaultPrice.measuringUnit : rawMaterial.measuringUnit,
                        });
                    }
                }
            });
        });


        result.codes.forEach((codeUsage) => {
            const article = articles.find((o: any) => o.id === codeUsage.id);
            if (!article) {
                return;
            }
            const labourcost = article.labourCosts.find((o: any) => o.type === data.projectType);
            if (!labourcost) {
                return;
            }

            result.expectedDurationInMinutes += labourcost.targetDuration * codeUsage.amount;
        });

        // result.expectedDurationInMinutes = Math.round(result.expectedDurationInMinutes);

        return result;
    },
    calculateAmountFromLine(usedArticle: IUsedArticle): number {
        let amount = 0; // Calculate total amount amount * height * length
        if (usedArticle.length && usedArticle.length !== null) {
            amount += usedArticle.length;
        }
        if (usedArticle.height && usedArticle.height !== null) {
            if (amount === 0) {
                amount += usedArticle.height;
            } else {
                amount *= usedArticle.height;
            }
        }
        if (usedArticle.amount && usedArticle.amount !== null) {
            if (amount === 0) {
                amount += usedArticle.amount;
            } else {
                amount *= usedArticle.amount;
            }
        }
        if (usedArticle.deduction) {
            amount = 0 - amount;
        }

        return amount;
    }
}